import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs} from "../../../AbstractElements";
import ApplicationTable from "../../DataTables/Applications/ApplicationTable";

const JobOfferApplicationsContainer = () => {
    const ApplStatus = "7";
    const Title = "Applications with Job Offers";
    const Desc = "Displays all applications that have reached the job offer stage of the recruitment process. This module provides a consolidated view of applicants who have been issued job offers, including their offer status, position details, and recruitment progress for monitoring and reference purposes.";
    return (
        <>
        <Breadcrumbs mainTitle="Job Offers" parent="Application Forms" />
        <Container fluid>
            <Row>
                <Col sm="12">
                    <Card>
                        <CardBody>
                            <ApplicationTable 
                            ApplStatus={ApplStatus} 
                            Title={Title} 
                            Desc={Desc}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
        </>
    );
};

export default JobOfferApplicationsContainer;
